import { Box, Tab, Typography } from "@mui/material";
import React from "react";
import Line from "./Charts/Revenue/Line";
import BarChart from "./Charts/Revenue/Bar";
import ChartTabs from "../Common/ChartTabs";
import Diversity from "./Charts/Revenue/Diversity";
import Scatter from "./Charts/Revenue/Scatter";
import VelocityPie from "./Charts/Revenue/VelocityPie";
import VolumePie from "./Charts/Revenue/Volume";
import ProductsPerMonth from "./Charts/Revenue/ProductsPerMonth";

export default function Charts(props: { value: number, id: number, height: number }){
    const [revenuePerMonth, setRevenuePerMonth] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    React.useEffect(() => {
      fetch(`/dashboard/revenue-per-month/${props.id}/?entity_id=${localStorage.getItem('entity_id')}`)
          .then(response => response.json())
          .then(data => {
            setCategories(data.categories);
            setRevenuePerMonth(data.revenue_per_month);
          });
  }, [localStorage.getItem('entity_id')]);

    return (
      <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-25px 0 0 0', padding: 0 }}>
        <ChartTabs tabs={[
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="Monthly Sales" value="0" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="Product Sales" value="1" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="Diversity" value="2" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="SKUs Purchased" value="3" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="Order Frequency" value="4" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="Volume" value="5" />,
          <Tab wrapped style={{ textTransform: 'capitalize' }} label="By Product Category by Month" value="6" />,
        ]} values={["0", "1", "2", "3", "4", "5", "6"]} ariaLabel="Customer revenue tabs" 
        panels={[
          revenuePerMonth.length > 0 ? (
            <Line data={revenuePerMonth} categories={categories} title="Monthly Sales Trend" height={props.height} />
          ) : (
            <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
          ),
          <BarChart title="Last 2 Years Sales vs Incremental Sales Opportunity" id={props.id} height={props.height} />,
          <Diversity title="Diversity" id={props.id} height={props.height} />,
          <Scatter title="SKUs Purchased" id={props.id} height={props.height} />,
          <VelocityPie title="Items purchase frequency" id={props.id} height={props.height} />,
          <VolumePie title="Volume" id={props.id} height={props.height} />,
          <ProductsPerMonth title="By Product Category by Month" id={props.id} height={props.height} />
        ]} />
      </Box>
    )
}